import React, { Fragment } from "react";

import classes from "./Modal.module.css";
import Backdrop from "../Backdrop/Backdrop";

const Modal = (props) => {
    if(props.showModal){
        return (
            <Fragment>
                <Backdrop show={props.showModal} closeBackdrop={props.closeModal} />
                <div className={classes.Modal}>
                    {props.children}
                </div>
            </Fragment>
        );
    }
    else{
        return null
    }
    
};

export default Modal;